import React /*, { useState } */ from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Logout } from "@mui/icons-material";

import "./SideBar.css";

const SideBar = () => {
	const redirect = useNavigate();

	const handleHomeRedirect = () => {
		redirect("/");
	};

	const handleLogout = async () => {
		try {
			const serverUrl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SERVER_HOST}:${process.env.REACT_APP_SERVER_HOST_PORT}`;
			await axios.post(
				`${serverUrl}/api/logout`,
				{},
				{ withCredentials: true }
			);
			redirect("/login");
		} catch (error) {
			console.error("Logout failed", error);
		}
	};

	return (
		<div className="sidebar">
			<div className="qflo-logo-sidebar">
				<img
					className=""
					alt="logo"
					src="/media/icons/logoV2.png"
					onClick={() => handleHomeRedirect()}
					style={{ cursor: "pointer" }}
				/>
				<img
					className=""
					alt="logo"
					src="/media/icons/lineImg.png"
				/>
			</div>
			<div
				className="qflo-logout-sidebar"
				onClick={handleLogout}
				style={{ cursor: "pointer" }}
			>
				<Logout style={{ color: "white", fontSize: "28px" }} />
			</div>
		</div>
	);
};

export default SideBar;
